const e = (n) => typeof n == "function", l = (...n) => function(t) {
  n.some((o) => (o?.(t), t?.defaultPrevented));
};
export {
  l as callAllHandlers,
  e as isFunction
};
//# sourceMappingURL=index.js.map
